import { Mail, Phone, MapPin, Send, Facebook, Instagram, Linkedin, Youtube, Loader2 } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/hlogo22.png";
import api from '../services/api';
/* ================== ANIMATION VARIANTS ================== */
const footerVariants = {
  // 'idle' | 'loading' | 'success'

  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.15,
    },
  },
};

const columnVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export default function Footer() {
 // Newsletter State
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  // NEW: Counselling Form State
  const [leadData, setLeadData] = useState({ fullName: "", phone: "" });
  const [leadStatus, setLeadStatus] = useState("idle");

  // Handler for Newsletter (Bottom Form)
  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      await api.post("/subscribe", { email, type: 'newsletter' });
      setStatus("success");
      setEmail("");
      setTimeout(() => setStatus("idle"), 3000);
    } catch (err) {
      setStatus("error");
      setTimeout(() => setStatus("idle"), 3000);
    }
  };

  // NEW: Handler for Counselling (Top Form)
  const handleCounsellingSubmit = async (e) => {
    e.preventDefault();
    if (!leadData.fullName || !leadData.phone) return;
    setLeadStatus("loading");
    try {
      await api.post("/subscribe", { ...leadData, type: 'counselling' });
      setLeadStatus("success");
      setLeadData({ fullName: "", phone: "" });
      setTimeout(() => setLeadStatus("idle"), 3000);
    } catch (err) {
      setLeadStatus("error");
      setTimeout(() => setLeadStatus("idle"), 3000);
    }
  };
  
  
  return (
    <>
      {/* ===== LEAD CAPTURE STRIP ===== */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true }}
        className="border-t border-white/10"
      >
        <div className="max-w-7xl mx-auto px-6 py-10">
          <div
            className="bg-white/10 backdrop-blur-xl rounded-2xl px-6 py-6
                    flex flex-col lg:flex-row gap-6 items-center justify-between"
          >
            {/* TEXT */}
            <div>
              <h3 className="text-white text-lg font-semibold">
                Get Free Counselling Today
              </h3>
              <p className="text-sm text-slate-400 mt-1">
                Leave your details — our experts will contact you.
              </p>
            </div>

            {/* FORM */}
            {/* UPDATED COUNSELLING FORM */}
            <form onSubmit={handleCounsellingSubmit} className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              <input
                type="text"
                required
                placeholder="Full Name"
                value={leadData.fullName}
                onChange={(e) => setLeadData({ ...leadData, fullName: e.target.value })}
                className="bg-white/10 border border-white/10 px-5 py-3 rounded-full text-sm text-white outline-none focus:border-[#5A74C9] w-full sm:w-56"
              />
              <input
                type="tel"
                required
                placeholder="Phone Number"
                value={leadData.phone}
                onChange={(e) => setLeadData({ ...leadData, phone: e.target.value })}
                className="bg-white/10 border border-white/10 px-5 py-3 rounded-full text-sm text-white outline-none focus:border-[#5A74C9] w-full sm:w-56"
              />
              <motion.button
                type="submit"
                disabled={leadStatus === "loading"}
                className="bg-[#2F4DA6] hover:bg-[#3B5BD8] text-white text-sm font-medium px-7 py-3 rounded-full flex items-center gap-2 justify-center"
              >
                {leadStatus === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : leadStatus === "success" ? "Sent!" : "Submit"}
                <Send className="w-4 h-4" />
              </motion.button>
            </form>
          </div>
        </div>
      </motion.div>

      <motion.footer
        className="bg-gradient-to-br from-[#0A1638] via-[#0B1F4A] to-[#050C1E] text-slate-300"
        variants={footerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-14">
          {/* BRAND + CONTACT */}
          <motion.div variants={columnVariants}>
            <Link to="/">
              <motion.div
                whileHover={{ scale: 1.04 }}
                className="relative inline-flex items-center justify-center transition"
              >
                {/* white glass reflection */}
                <div
                  className="
      pointer-events-none absolute inset-0 rounded-2xl
      bg-gradient-to-br from-white/60 via-white/20 to-transparent
      opacity-50
    "
                />

                <img
                  src={logo}
                  alt="Good Will Global Solutions"
                  className="relative w-56 drop-shadow-xl"
                />
              </motion.div>
            </Link>

            <div className="mt-10 space-y-5 text-sm">
              {[
                { icon: Mail, text: "info@goodwillglobalsolutions.com" },
                { icon: Phone, text: "+91 7386252108 " },
                {
                  icon: MapPin,
                  text: "H No. 3-1/145, 5th floor, Neknampur, Gandipet, Manikonda,K.V. Rangareddy dist. 500089",
                },
              ].map(({ icon: Icon, text }, i) => (
                <motion.div
                  key={i}
                  whileHover={{ x: 6 }}
                  className="group flex items-center gap-4 cursor-pointer"
                >
                  <div
                    className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center
                                group-hover:bg-[#2F4DA6] transition"
                  >
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <span className="group-hover:text-white transition">
                    {text}
                  </span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* SERVICES */}
          <motion.div variants={columnVariants}>
            <h4 className="text-white font-semibold mb-8">
              Our Services
              <span className="block w-8 h-[2px] bg-[#5A74C9] mt-2" />
            </h4>

            <ul className="space-y-4">
              {[
                {
                  name: "Door to Door Counselling",
                  slug: "door-to-door-counselling",
                },
                { name: "University Selection", slug: "university-selection" },
                { name: "Test Preparation", slug: "test-preparation" },
                {
                  name: "Application Assistance",
                  slug: "application-assistance",
                },
                { name: "Financial Assistance", slug: "financial-assistance" },
                { name: "Visa Guidance", slug: "visa-guidance" },
                {
                  name: "Pre-Departure Assistance",
                  slug: "pre-departure-assistance",
                },
                {
                  name: "Accommodation Assistance",
                  slug: "accommodation-assistance",
                },
                {
                  name: "Post-Arrival Assistance",
                  slug: "post-arrival-assistance",
                },
              ].map((item) => (
                <motion.li
                  key={item.slug}
                  whileHover={{ x: 6 }}
                  className="flex items-center gap-3 text-sm text-slate-400"
                >
                  <span className="w-2 h-[2px] bg-[#5A74C9]" />

                  <Link
                    to={`/services/${item.slug}`}
                    className="hover:text-white transition"
                  >
                    {item.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* DESTINATIONS */}
          <motion.div variants={columnVariants}>
            <h4 className="text-white font-semibold mb-8">
              Destinations
              <span className="block w-8 h-[2px] bg-[#5A74C9] mt-2" />
            </h4>

            <ul className="space-y-4">
              {[
                { name: "United Kingdom", slug: "uk" },
                { name: "Australia", slug: "australia" },
                { name: "Canada", slug: "canada" },
                { name: "Germany", slug: "germany" },
                { name: "United States", slug: "usa" },
                { name: "New Zealand", slug: "newzealand" },
                { name: "Ireland", slug: "ireland" },
                { name: "France", slug: "france" },
              ].map((item) => (
                <motion.li
                  key={item.slug}
                  whileHover={{ x: 6 }}
                  className="flex items-center gap-3 text-sm text-slate-400"
                >
                  <span className="w-2 h-[2px] bg-[#5A74C9]" />

                  <Link
                    to={`/study/${item.slug}`}
                    className="hover:text-white transition"
                  >
                    {item.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* NEWSLETTER + SOCIALS */}
          <motion.div variants={columnVariants}>
            <h4 className="text-white font-semibold mb-8">
              Newsletter
              <span className="block w-8 h-[2px] bg-[#5A74C9] mt-2" />
            </h4>

            <p className="text-sm text-slate-400 mb-6">
              Join 10,000+ global dreamers and get updates in your inbox.
            </p>

            <div className="flex items-center bg-white/10 rounded-full px-4 py-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={
                  status === "success" ? "Thank you!" : "Your email address"
                }
                className="bg-transparent flex-1 text-sm outline-none placeholder:text-slate-400 disabled:opacity-50"
                disabled={status === "loading"}
              />
              <motion.button
                onClick={handleSubscribe}
                disabled={status === "loading"}
                whileHover={{ scale: status === "loading" ? 1 : 1.1 }}
                whileTap={{ scale: 0.9 }}
                className="w-10 h-10 rounded-full bg-[#2F4DA6] flex items-center justify-center transition-colors hover:bg-[#3b5bc0] disabled:bg-slate-500"
              >
                {status === "loading" ? (
                  <Loader2 className="w-4 h-4 text-white animate-spin" />
                ) : (
                  <Send className="w-4 h-4 text-white" />
                )}
              </motion.button>
            </div>
            {status === "error" && (
              <p className="text-red-400 text-xs mt-2">
                Something went wrong. Try again.
              </p>
            )}
            <div className="mt-10 flex gap-4">
              {[
                {
                  Icon: Facebook,
                  url: "https://www.facebook.com/share/17yyUmZQRR/",
                },
                {
                  Icon: Instagram,
                  url: "https://www.instagram.com/goodwill_global_sol?igsh=MXF3OTBlZXBsNWY0",
                },
                {
                  Icon: Linkedin,
                  url: "https://www.linkedin.com/company/goodwill-global-solutions/",
                },
              ].map(({ Icon, url }, i) => (
                <motion.a
                  key={i}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -4, scale: 1.1 }}
                  className="w-11 h-11 rounded-xl bg-white/10 hover:bg-[#2F4DA6]
                 flex items-center justify-center transition"
                >
                  <Icon className="w-5 h-5 text-white" />
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>

        {/* BOTTOM BAR */}
      {/* BOTTOM BAR */}
<div className="border-t border-white/10 py-6 px-6">
  <div className="max-w-7xl mx-auto flex justify-center items-center">
    
    <p className="text-xs text-slate-400 text-center leading-relaxed max-w-full lg:whitespace-nowrap">
      © 2026 Good Will Global Solutions. Designed and Developed with Excellence by{" "}

      <motion.a
        href="https://avies.in"
        animate={{
          textShadow: [
            "0 0 5px rgba(255,255,255,0.3)",
            "0 0 12px rgba(255,255,255,0.9)",
            "0 0 20px rgba(90,116,201,1)",
            "0 0 12px rgba(255,255,255,0.9)",
            "0 0 5px rgba(255,255,255,0.3)",
          ],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
        }}
        className="font-bold text-white tracking-widest"
      >
        AVIES
      </motion.a>{" "}
      . All Rights Reserved.
    </p>

  </div>
</div>
      </motion.footer>
    </>
  );
}
